export interface ClientVersionDistribution {
  latestClientVersion: string;
  previousClientVersion: string;
  latestClientVersionCount: number;
  previousClientVersionCount: number;
  otherClientVersionsCount: number;
}

export interface PlayerStatistics {
  activeLast24HoursCount: number;
  activeLast30DaysCount: number;
  ios: ClientVersionDistribution;
  android: ClientVersionDistribution;
  other: ClientVersionDistribution;
  clientVersions: string[];
}

export const emptyVersionDistribution = (): ClientVersionDistribution => ({
  latestClientVersion: '',
  previousClientVersion: '',
  latestClientVersionCount: 0,
  previousClientVersionCount: 0,
  otherClientVersionsCount: 0,
});
